import { render, staticRenderFns } from "./FootMeun.vue?vue&type=template&id=27420f5d&scoped=true"
import script from "./FootMeun.vue?vue&type=script&lang=js"
export * from "./FootMeun.vue?vue&type=script&lang=js"
import style0 from "./FootMeun.vue?vue&type=style&index=0&id=27420f5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27420f5d",
  null
  
)

export default component.exports